import React, { useEffect } from 'react'
import Dropdown from '../../shared/components/Dropdown';
import _ from 'lodash';

const styles = {
    menuProps: {
        sx: {
            '.MuiPaper-root': {
                maxHeight: '40%',
            },
        },
    },
}

const FlowOptions = [
    {
        id:1,
        value:"Sub"
    },
    {
        id:2,
        value:"Master"
    }
]

const FlowTypeDropdown = (props) => {
    const { flowType, onChangeFlow } = props;

    useEffect(() => {
        if (!_.isEmpty(FlowOptions)) {
            onChangeFlow(FlowOptions?.id, FlowOptions?.value)
        }
    }, [FlowOptions])

    const onChange = (value) => {
        if (value) {
            const obj = _.find(FlowOptions, m => m?.id === value);
            onChangeFlow(value, obj?.value)
        } else {
            onChangeFlow(value, value)
        }
    }
    return (
        <>
            <Dropdown
                placeholder=' Select Flow Type'
                margin="dense"
                className="user-dropdown"
                style={{ width: '100%', height: '42px', marginTop: '-20px' }}
                inputProps={{ 'aria-label': 'Without label' }}
                options={FlowOptions}
                valueKey='value'
                labelKey='value'
                onChange={(e) => onChange(e)}
                value={flowType}
                MenuProps={styles.menuProps}
                defaultValue={!_.isEmpty(FlowOptions) ? FlowOptions[0] : ""}
            //    isClear={isClear}
            />
        </>
    )
}

export default FlowTypeDropdown;